import { render, staticRenderFns } from "./rankdetail.vue?vue&type=template&id=de751610&scoped=true&"
import script from "./rankdetail.vue?vue&type=script&lang=js&"
export * from "./rankdetail.vue?vue&type=script&lang=js&"
import style0 from "./rankdetail.vue?vue&type=style&index=0&id=de751610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de751610",
  null
  
)

export default component.exports